
import React, { Component } from 'react';
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import Highcharts from 'highcharts'
import variablePie from "highcharts/modules/variable-pie.js";
variablePie(Highcharts);

class Chart1 extends Component {
    constructor() {
        super();
        this.state = {
            data: null
        }
    }
    componentDidMount() {
        Alert.Loading(true)
        var where = {}
        if (this.props.selected_dealer) {
            where.dealer_code = [this.props.selected_dealer]
        }
        APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1L, where, ({ datas }) => {
            this.setState({
                data: datas
            }, () => {
                Alert.LoadingClose()
                this.setChart(datas)
            })
        })
    }
    getValue = (raw_data, qtr_num, key_num) => {
        var res = 0
        if (raw_data[qtr_num] && raw_data[qtr_num][key_num]) {
            res = Math.round(raw_data[qtr_num][key_num])
        }
        return res
    }
    setChart(datas) {
        Highcharts.chart('chart_3_1_NPS', {
            chart: {
                type: 'column'
            },
            // colors: colors,
            title: {
                text: '% NPS-OS'
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [
                    'By Quarter'
                ],
                crosshair: true
            },
            yAxis: {
                // min: 0,
                title: {
                    text: 'NPS'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>NPS: {point.y:.0f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [{
                name: 'Quarter 2/FY21',
                data: [(this.getValue(datas, "qtr2", "c_per") - this.getValue(datas, "qtr2", "a_per"))],
                dataLabels: {
                    enabled: true,
                    verticalAlign: 'bottom',
                    overflow: 'none',
                    crop: false,
                    //y: 20,
                    formatter() {
                        return this.point.y;
                    }
                }
            }, {
                name: 'Quarter 3/FY21',
                data: [(this.getValue(datas, "qtr3", "c_per") - this.getValue(datas, "qtr3", "a_per"))],
                dataLabels: {
                    enabled: true,
                    verticalAlign: 'bottom',
                    overflow: 'none',
                    crop: false,
                    //y: 20,
                    formatter() {
                        return this.point.y;
                    }
                }

            }, {
                name: 'Quarter 4/FY21',
                data: [(this.getValue(datas, "qtr4", "c_per") - this.getValue(datas, "qtr4", "a_per"))],
                color: "#8bc34a",
                dataLabels: {
                    enabled: true,
                    verticalAlign: 'bottom',
                    overflow: 'none',
                    crop: false,
                    //y: 20,
                    formatter() {
                        return this.point.y;
                    }
                }
            },
            {
                name: 'Quarter 1/FY21',
                data: [(this.getValue(datas, "qtr1", "c_per") - this.getValue(datas, "qtr1", "a_per"))],
                dataLabels: {
                    enabled: true,
                    verticalAlign: 'bottom',
                    overflow: 'none',
                    crop: false,
                    //y: 20,
                    formatter() {
                        return this.point.y;
                    }
                }
            }]
        });
    }
    handleClickChart = (e, categories, series) => {
        if (!this.props.callbackChangelevel) return
        var range_name = 2
        switch (e.point.colorIndex) {
            case 0:
                range_name = "% Top 2 Box"
                break;
            case 1:
                range_name = "% Rating 7-8"
                break;
            case 2:
                range_name = "% Bottom 0-6"
                break;
        }
        var quarter_number = 2
        switch (e.point.category) {
            case "Quarter 2/21":
                quarter_number = 2
                break;
            case "Quarter 3/21":
                quarter_number = 3
                break;
            case "Quarter 4/22":
                quarter_number = 4
                break;
            case "Quarter 1/22":
                quarter_number = 1
                break;

        }
        console.log(e.point.colorIndex)
        this.props.callbackChangelevel({
            level: 2,
            quarter_name: e.point.category,
            quarter_number: quarter_number,
            range_name: range_name,
            range_point: e.point.colorIndex
        })
    }
    render() {
        return (
            <div className={"chart-box"}>
                <center>
                    <div id="chart_3_1_NPS" style={{ width: "92%", height: "350px" }}></div>
                </center>
            </div>
        );
    }
}

export default Chart1;